import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { CheckCircle } from '@mui/icons-material';
import SwitchMui from '@mui/material/Switch';
import { Box } from '@mui/material';
import styles from './styles';

const SwitchRaw = ({
  className, value, checked, onChange, ...props
}) => (
  <Box className={{
    [className]: className,
    'dn-small': !value,
  }}
  >
    <SwitchMui
      icon={
        <CheckCircle />
      }
      checkedIcon={
        <CheckCircle />
      }
      checked={checked}
      onChange={onChange}
      sx={{
        '.MuiSwitch-track': {
          '&:before': {
            content: `'${value || ''}'`,
          },
        },
      }}
      {...props}
    />
  </Box>
);

SwitchRaw.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

const Switch = styled(SwitchRaw)(styles);

Switch.propTypes = SwitchRaw.propTypes;

export default Switch;
